import { render } from "./HeroView.vue?vue&type=template&id=1bda0087&scoped=true"
import script from "./HeroView.vue?vue&type=script&lang=js"
export * from "./HeroView.vue?vue&type=script&lang=js"

import "./HeroView.vue?vue&type=style&index=0&id=1bda0087&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bda0087"]])

export default __exports__